// Web shim for react-native-device-info
// On web, we read version from package.json at build time

import pkg from '../../package.json';

const DeviceInfo = {
  getVersion: () => pkg.version,
  getBuildNumber: () => '1',
  getUniqueId: async () => 'web',
  getUniqueIdSync: () => 'web',
  getDeviceId: () => 'web',
  getSystemName: () => 'Web',
  getSystemVersion: () => navigator.userAgent,
  getBrand: () => 'Web',
  getModel: () => 'Browser',
  isTablet: () => window.innerWidth >= 768,
  getDeviceType: () => 'Handset',
  isEmulator: async () => false,
  isEmulatorSync: () => false,
};

export const isTablet = () => window.innerWidth >= 768;

export default DeviceInfo;
